import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import { Pagination, Button, Row, Popover, Spin, Modal } from 'antd'
import { app, api, config } from "../../../app"
import NewsDetail from "../../../components/NewsDetail"

class TMNews extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataList: [],
            data_loading: true,
            page: 1,
            total: 0,
            teamno: props.match.params.teamno,
            teamname: "正在加载 ... ",
            news_detail_visible: false,
            newsInfo: {},
            news_detail_loading: false,
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.handleData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { teamno } = this.state,
            params = {
                page,
                object_type: 3,
                object: teamno,
            }, { flag, data, msg, total, teamname } = await app.post(api.NewsTeamNewsList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            this.setData({ teamname, data_loading: false, dataList: data, total: parseInt(total || 0) })
        }
    }

    /**
     * 查看新闻详情
     * @param id
     */
    handleNewsDetail = async (id) => {
        await this.setData({ news_detail_visible: true, news_detail_loading: true })
        let state = { news_detail_loading: false }
        let { flag, data, msg } = await app.post(api.NewNewsDetails, {
            id,
            request: 'news',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            data.id = id
            state.newsInfo = data
        } else {
            app.alert(msg, 'error')
        }
        await this.setData(state)
    }

    render () {
        let { data_loading, teamname, dataList, total, page, news_detail_visible, newsInfo, news_detail_loading } = this.state
        return (
            <div className="teamnews-page">
                <Row className="teamnews-title" type="flex" justify="space-between">
                    <span>队伍新闻</span>
                    <Button type="primary" onClick={() => this.props.history.go(-1)}>返回</Button>
                </Row>
                <div className="tp-content">
                    <div className="tp-title">{teamname}</div>
                    <div className="tp-list">
                        {
                            data_loading ? (<div style={{textAlign: 'center', padding: '30px 0'}}><Spin/></div>) : dataList.map((item, i) => {
                                return (
                                    <div className="tpl-item" key={i}
                                         onClick={() => this.handleNewsDetail(item.id)}
                                    >
                                        <div className="tn-img">
                                            <img src={config.imgUrl + item.news_img}  alt=""/>
                                        </div>
                                        <div className="tn-info">
                                            <div className="tn-title">{item.news_title}</div>
                                            <div className="tn-date">
                                                <span>{item.release_time}</span>
                                                <div className="tn-icon">
                                                <span>
                                                    <i className="iconfont icon-yuedu" style={{ fontSize: '.6rem' }}/>
                                                    <span style={{ padding: '0 .25rem' }}>{item.hits || 0}</span>
                                                </span>
                                                    <Popover placement="right" title="手机扫码分享" content={
                                                        <QRCode value={config.shareDoman + item.id}/>
                                                    } overlayStyle={{ textAlign: 'center' }}>
                                                                    <span style={{ marginLeft: '.25rem' }}>
                                                                        <i className="iconfont icon-fenxiang"
                                                                           style={{
                                                                               fontSize: '.6rem',
                                                                               color: '#5E92B4'
                                                                           }}/>
                                                                        <span style={{ padding: '0 .25rem' }}>分享</span>
                                                                    </span>
                                                    </Popover>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <Pagination
                        total={total}
                        current={page}
                        pageSize={20}
                        size="small"
                        showTotal={(total) => `总数量：${total}`}
                        onChange={this.handleData}
                        style={{ textAlign: "center", padding: 20 }}
                    />
                </div>
                <Modal
                    visible={news_detail_visible}
                    footer={null}
                    title="新闻详情"
                    maskClosable={false}
                    width='100%'
                    style={{ top: 0, height: '100vh' }}
                    bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'auto' }}
                    onCancel={() => this.setData({news_detail_visible: false})}
                    zIndex={2999}
                    className="news-detail-modal-class"
                >
                    <NewsDetail data={newsInfo} loading={news_detail_loading}/>
                </Modal>
            </div>
        )
    }
}

export default TMNews



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamMore/TMNews.jsx